import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFileCirclePlus,
    faFilePen,
    faUserGear,
    faUserPlus,
    faRightFromBracket,
    faHouse,
    faDumbbell,
    faCalendar,
    faEnvelope
} from "@fortawesome/free-solid-svg-icons"
import { useNavigate, Link, useLocation } from 'react-router-dom'
import { useSendLogoutMutation } from '../features/auth/authApiSlice'
import useAuth from '../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import { useGetTodosPastdueQuery} from "../features/todo/todoApiSlice"


const HEP_REGEX = /^\/dash\/hep(\/)?$/
const USERS_REGEX = /^\/dash\/users(\/)?$/
const EXERCISES_REGEX = /^\/dash\/exercises(\/)?$/
const TODOS_REGEX = /^\/dash\/todos(\/)?$/

const DashHeader = () => {
    const { userId, isManager, isAdmin } = useAuth()

    const navigate = useNavigate()
    const { pathname } = useLocation()

    const [recordCount, setRecordCount] = useState(0)

    
    // set date for past due Todo's
    const date = new Date()
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
    
    const { data } =  useGetTodosPastdueQuery({due_date: formattedDate, user_id: userId})

    useEffect(() => {
        if (data) {
            if (data?.message) {
                setRecordCount(0)
                toast.error(data?.message);    
            } else {
                setRecordCount(data.length)
            }
        }
    
    }, [data ])

    const [sendLogout, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useSendLogoutMutation()

    useEffect(() => {
        if (isSuccess) navigate('/')
        
        if (isError) {
            toast.error(error?.data?.message);
        }
    }, [isSuccess, navigate, isError, error])


    const onNewHepClicked = () => navigate('/dash/hep/new')
    const onNewUserClicked = () => navigate('/dash/users/new')
    const onNewExerciseClicked = () => navigate('/dash/exercises/new')
    const onHepsClicked = () => navigate('/dash/hep')
    const onUsersClicked = () => navigate('/dash/users')
    const onExercisesClicked = () => navigate('/dash/exercises')
    const onExerciseListClicked = () => navigate('/dash/exerciselist')
    const onTodoClicked = () => navigate('/dash/todos')
    const onProfileClicked = () => navigate(`/dash/profile/${userId}`)
    const onHelpClicked= () => navigate('/dash/help')

    let newHepButton = null
    if (HEP_REGEX.test(pathname)) {
        newHepButton = (
            <li className="nav-item">
                <span className="nav-link nav-icon" role="button" onClick={onNewHepClicked}><FontAwesomeIcon icon={faFileCirclePlus} />New HEP</span>
            </li>
        )
    }

    let newUserButton = null
    if (USERS_REGEX.test(pathname)) {
        newUserButton = (
            <li className="nav-item">
                <span className="nav-link nav-icon" role="button" onClick={onNewUserClicked}><FontAwesomeIcon icon={faUserPlus} />New User</span>
            </li>
        )
    }

    let newExerciseButton = null
    if (EXERCISES_REGEX.test(pathname)) {
        newExerciseButton = (
            <li className="nav-item">
                <span className="nav-link nav-icon" role="button" onClick={onNewExerciseClicked}><FontAwesomeIcon icon={faDumbbell} />New Exercise</span>
            </li>
        )
    }

    let userButton = null
    if (isManager || isAdmin) {
        if (!USERS_REGEX.test(pathname) && pathname.includes('/dash')) {
            userButton = (
                <li className="nav-item">
                     <span className="nav-link nav-icon" role="button" onClick={onUsersClicked}><FontAwesomeIcon icon={faUserGear} />Users</span>
                </li>
            )
        }
    }

    let profileButton = null
    if (!isAdmin) {
        profileButton = (
            <li className="nav-item">
                <span className="nav-link nav-icon" role="button" onClick={onProfileClicked}><FontAwesomeIcon icon={faUserGear} />My Profile</span>
            </li>
        )
    }

    let HepButton = null
    if (!HEP_REGEX.test(pathname) && pathname.includes('/dash')) {
        HepButton = (
            <li className="nav-item">
                <span className="nav-link nav-icon" role="button" onClick={onHepsClicked}><FontAwesomeIcon icon={faFilePen} />Home Programs</span>
           </li>
        )
    }

    let exerciseButton = null
    if (isAdmin) {
        if (!EXERCISES_REGEX.test(pathname) && pathname.includes('/dash')) {
            exerciseButton = (
                <li className="nav-item">
                     <span className="nav-link nav-icon" role="button" onClick={onExercisesClicked}><FontAwesomeIcon icon={faDumbbell} />Exercises</span>
                </li>
            )
        }
    } else {
        if (!EXERCISES_REGEX.test(pathname) && pathname.includes('/dash')) {
            exerciseButton = (
                <li className="nav-item">
                     <span className="nav-link nav-icon" role="button" onClick={onExerciseListClicked}><FontAwesomeIcon icon={faDumbbell} />Exercises</span>
                </li>
            )
        }
    }

    let todoButton = null
    if (!TODOS_REGEX.test(pathname) && pathname.includes('/dash')) {
        if (recordCount!==0) {
            todoButton = (
                <li className="nav-item">
                        <span className="nav-link nav-icon" role="button" onClick={onTodoClicked} style={{color:'yellow'}}><FontAwesomeIcon icon={faCalendar}  />ToDo: {recordCount}</span>
                </li>
            )    
        } else {
            todoButton = (
                <li className="nav-item">
                        <span className="nav-link nav-icon" role="button" onClick={onTodoClicked}><FontAwesomeIcon icon={faCalendar}/>ToDo</span>
                </li>
            )    
        }
    }


    const logoutButton = (
        <li className="nav-item">
            <span className="nav-link nav-icon" role="button" onClick={sendLogout}><FontAwesomeIcon icon={faRightFromBracket} />Logout</span>
        </li>
    )
    let helpButton=null
    if (!isAdmin) {
        helpButton = (
            <li className="nav-item">
                <span className="nav-link nav-icon" role="button" onClick={onHelpClicked}><FontAwesomeIcon icon={faEnvelope} />Help</span>
            </li>
        )
    }


    let buttonContent
    if (isLoading) {
        buttonContent = <PulseLoader color={"#5f788a"} />
    } else {
        buttonContent = (
            <>
                {newHepButton}
                {newUserButton}
                {newExerciseButton}
                {HepButton}
                {exerciseButton}
                {userButton}
                {todoButton}
                {profileButton}
                {helpButton}
                {logoutButton}
            </>
        )
    }

    const content = (
        <nav className="navbar navbar-expand-sm navbar-dark" style={{ background: "linear-gradient(to right, lightgrey, #5f788a)" }}>
            <div className="container-fluid">
                <Link to="/dash" style={{textDecoration:"none"}}>
                    <h1 className="navbar-brand mb-0 h1"><FontAwesomeIcon icon={faHouse} /> DPE</h1>
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#Navbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="Navbar" data-bs-toggle="collapse" data-bs-target=".navbar-collapse">
                    <ul className="navbar-nav ms-auto">
                        {buttonContent}
                    </ul>
                </div>
            </div>
        </nav>
    )

    return content
}
export default DashHeader